<template>
  <section class="partners__item">
    <figure>
      <img
        :src="
          'https://arquivos.sistematodos.com.br/ArquivosLogotipoEmpresa/' +
          data.NomeImagem
        "
        alt
      />
    </figure>
    <div class="partners__item__text">
      <h3>{{ data.NomeFantasia }} - {{ data.Unidade }}</h3>
      <p>{{ data.Logradouro }}, N°: {{ data.Numero }} {{ data.Complemento }}</p>
      <p>{{ ContatoTelefone }}(11) 2095-5300</p>
    </div>
    <a
      :href="
        'https://www.google.com/maps/search/?api=1&query=' +
        data.Logradouro +
        ',+' +
        data.Numero +
        ',+' +
        data.Cidade +
        ''
      "
      target="_blank"
    >
      Localização
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17.52"
        height="27.309"
        viewBox="0 0 17.52 27.309"
      >
        <g
          id="Grupo_3277"
          data-name="Grupo 3277"
          transform="translate(-171.952 -642.78)"
        >
          <path
            id="Caminho_4915"
            data-name="Caminho 4915"
            d="M180.713,670.089a.846.846,0,0,0,.724-.412c.328-.554,8.034-13.585,8.034-18.138a8.76,8.76,0,0,0-17.52,0c0,4.553,7.709,17.584,8.036,18.138A.844.844,0,0,0,180.713,670.089Zm0-25.625a7.084,7.084,0,0,1,7.075,7.075c0,3.068-4.587,11.7-7.075,16.036-2.49-4.337-7.077-12.969-7.077-16.036A7.086,7.086,0,0,1,180.713,644.464Z"
            transform="translate(0 0)"
          />
          <path
            id="Caminho_4916"
            data-name="Caminho 4916"
            d="M183.056,649.3a4.583,4.583,0,1,0-4.583,4.587A4.589,4.589,0,0,0,183.056,649.3Zm-4.583,2.9a2.9,2.9,0,1,1,2.9-2.9A2.9,2.9,0,0,1,178.473,652.2Z"
            transform="translate(2.24 2.239)"
          />
        </g>
      </svg>
    </a>
  </section>
</template>

<script>
export default {
  props: ["data"],
};
</script>

<style lang="scss">
.partners {
  &__item {
    border: 1px solid #cbb7c1;
    padding: 15px 30px 24px;

    figure {
      margin: 0;
      text-align: center;
      img {
        border: 1px solid #cbb7c1;
        border-radius: 50%;
        width: 92px;
        height: 92px;
        object-fit: cover;
      }
    }

    a {
      text-align: center;
      text-decoration: none;
      font-family: "Lato", sans-serif;
      font-weight: 700;
      color: $color-gray;
      background: $color-yellow;
      border: 2px solid $color-yellow;
      padding: 14px 60px;
      border-radius: 31px;
      transition: 0.3s ease-in-out;
      position: relative;
      display: flex;
      svg {
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
        fill: $color-gray;
      }
      &:hover {
        color: $color-yellow;
        background: $color-gray;

        svg {
          fill: $color-yellow;
        }
      }
    }

    h3 {
      font-weight: 700;
      font-size: 14px;
      text-align: center;
      margin-top: 19px;
      text-transform: capitalize;
      color: #1a1a1a;
    }

    &__text {
      p {
        margin: 20px 0;
        text-align: center;
        height: 36px;
        margin: 8px 0;
        font-weight: 400;
        color: #3b3b3b;
      }
    }
  }
}
</style>
